import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	({ transitions, spacing, breakpoints, palette }) => ({
		root: {
			alignItems: 'center',
			position: 'relative',
		},
		background: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			maxWidth: '100%',
			overflow: 'hidden',
			backgroundPositionY: ({ metaData }) => metaData.backgroundImagePosition?.metaValue || 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			'&:after': {
				content: '""',
				transition: transitions.create('opacity'),
				backgroundColor: 'black',
				width: '100%',
				height: '100%',
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: ({ metaData, isMobile }) =>
					(isMobile ? metaData.mobileOpacity?.toNumber() : metaData.opacity?.toNumber() || 0) / 100,
			},
		},
		left: {
			'& $paper': {
				marginTop: 0,
				marginBottom: spacing(4),

				[breakpoints.down('xs')]: {
					marginBottom: 0,
				},
			},
		},
		text: {
			[breakpoints.down('xs')]: {
				'& *': {
					textAlign: ({ metaData }) => metaData.mobileAlignment?.metaValue,
				},
			},
		},
		mobileImage: {
			marginLeft: spacing(-3),
			marginRight: spacing(-3),
		},
		imageWrap: {
			marginTop: spacing(2),
			marginBottom: spacing(3.5),
		},
		paper: {
			zIndex: 1,
			margin: '0 auto',
			maxWidth: spacing(65),
			borderRadius: 11,
			[breakpoints.up('md')]: {
				marginTop: 0,
			},
			border: palette.common.borderColor !== 'transparent' ? `1px solid ${palette.common.borderColor}` : null,
		},
		empty: {
			[breakpoints.down('sm')]: {
				display: 'none',
			},
		},
		formBox: {
			padding: spacing(4, 2.5, 3.5),
			[breakpoints.up('md')]: {
				padding: spacing(4),
			},
		},
	}),
	{ name: 'Forms-2' },
)

export default useStyles
